const TermsTextArea = ({ terms, setTerms, termsError }) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const caretPos = event.target.selectionStart;
      setTerms((prevTerms) => {
        const start = prevTerms.slice(0, caretPos);
        const end = prevTerms.slice(caretPos);
        return `${start}\n${end}`;
      });
    }
  };
  const handleChange = (event) => {
    setTerms(event.target.value);
  };
  return (
    <>
      <textarea
        className="print:hidden w-[300px] h-16 md:w-full   border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Enter your terms and conditions here"
        //   onKeyDown={handleKeyDown}
        value={terms}
        onKeyDown={handleKeyDown}
        onChange={handleChange}
      />
      {termsError && (
        <p className="text-rose-600 animate__animated animate__fadeIn text-xs font-normal">
          {termsError}
        </p>
      )}
      {terms &&
        terms.split('\n').map((term, index) => (
          <p
            className="text-xs animate__animated animate__fadeIn pb-1"
            key={index}
          >
            {index + 1}.&nbsp;{term}
          </p>
        ))}
    </>
  );
};

export default TermsTextArea;
